/* THE AI MARK — what marks a figure or a sentence a model wrote, ONE component so a reader learns one mark. It is CLAUDE'S
   OWN SPARK since 2026-10-21 (Jay, on the Project Status card: "Considering it's Claude, please change to Claude's icon";
   Max: "bạn xem đổi nhé"): the portal's AI is Claude, so the mark says which one. The path is Anthropic's Claude logo as
   it ships with the Claude Code extension, in its own colour #D97757. Before it: a pink-to-orange "AI" pill (Max's pick
   from two stock sheets, the same afternoon) and, from 2026-10-18, a lilac "✦ AI" text pill on SCT vs actual and the
   Daily Output data check — those two screens carry this mark too. No text node inside, so a cell's text stays its own;
   the fill is named, so the global `* { color }` cannot turn it grey. `size` is the height in px. */
import React, { useEffect, useId, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import './AiTag.css';

const CLAUDE_SPARK = 'M4.709 15.955l4.72-2.647.08-.23-.08-.128H9.2l-.79-.048-2.698-.073-2.339-.097-2.266-.122-.571-.121L0 11.784l.055-.352.48-.321.686.06 1.52.103 2.278.158 1.652.097 2.449.255h.389l.055-.157-.134-.098-.103-.097-2.358-1.596-2.552-1.688-1.336-.972-.724-.491-.364-.462-.158-1.008.656-.722.881.06.225.061.893.686 1.908 1.476 2.491 1.833.365.304.145-.103.019-.073-.164-.274-1.355-2.446-1.446-2.49-.644-1.032-.17-.619a2.97 2.97 0 01-.104-.729L6.283.134 6.696 0l.996.134.42.364.62 1.414 1.002 2.229 1.555 3.03.456.898.243.832.091.255h.158V9.01l.128-1.706.237-2.095.23-2.695.08-.76.376-.91.747-.492.584.28.48.685-.067.444-.286 1.851-.559 2.903-.364 1.942h.212l.243-.242.985-1.306 1.652-2.064.73-.82.85-.904.547-.431h1.033l.76 1.129-.34 1.166-1.064 1.347-.881 1.142-1.264 1.7-.79 1.36.073.11.188-.02 2.856-.606 1.543-.28 1.841-.315.833.388.091.395-.328.807-1.969.486-2.309.462-3.439.813-.042.03.049.061 1.549.146.662.036h1.622l3.02.225.79.522.474.638-.079.485-1.215.62-1.64-.389-3.829-.91-1.312-.329h-.182v.11l1.093 1.068 2.006 1.81 2.509 2.33.127.578-.322.455-.34-.049-2.205-1.657-.851-.747-1.926-1.62h-.128v.17l.444.649 2.345 3.521.122 1.08-.17.353-.608.213-.668-.122-1.374-1.925-1.415-2.167-1.143-1.943-.14.08-.674 7.254-.316.37-.729.28-.607-.461-.322-.747.322-1.476.389-1.924.315-1.53.286-1.9.17-.632-.012-.042-.14.018-1.434 1.967-2.18 2.945-1.726 1.845-.414.164-.717-.37.067-.662.401-.589 2.388-3.036 1.44-1.882.93-1.086-.006-.158h-.055L4.132 18.56l-1.13.146-.487-.456.061-.746.231-.243 1.908-1.312-.006.006z';

export default function AiTag({ size = 16, title, className = '', testid }) {
  return (
    <svg className={`ai-tag ${className}`.trim()} width={size} height={size} viewBox="0 0 24 24"
      role={title ? 'img' : undefined} aria-hidden={title ? undefined : 'true'} data-testid={testid}>
      {title && <title>{title}</title>}
      <path d={CLAUDE_SPARK} fill="#D97757" fillRule="nonzero" />
    </svg>
  );
}

/* A STATUS THE AI WROTE, AND ITS NOTE (Max, 2026-10-21, on the browser's own grey tooltip under it: "cái note tôi đang
   muốn nó có hiệu ứng khung hoặc hiển thị để nhìn nó AI và đẹp cool hơn á"). The pill carries the mark; hovering it — or
   reaching it with Tab — opens a card in Claude's colours: a gradient frame that drifts slowly, "Claude summary", the
   phrase and the facts behind it (a foot line saying a model wrote it went the same day — Max: "ko cần dòng này";
   `note` stays for a caller that wants one). Drawn into <body> and fixed, so the table's own
   scrolling box cannot clip it; opens below the pill, above it near the foot of the window; any scroll or Escape closes
   it. No native `title`: two notes for one hover is one too many. */
export function AiStatusPill({ text, why, note, head, className = '', testid, tagTestid, seed = '' }) {
  const ref = useRef(null);
  /* THE SPARK IS ALIVE (Max, 2026-10-21: "nếu có hiệu ứng thì sẽ okie hơn"): it turns slowly and breathes; a project
     still being written turns it fast, the way Claude's own spark does while it thinks. A column of them turning in step
     reads as a machine, so each pill starts its turn at a point of its own, taken from `seed` (the project's key). */
  const delay = `${-([...String(seed)].reduce((h, c) => (h * 31 + c.charCodeAt(0)) % 16000, 7) / 1000)}s`;
  const [pos, setPos] = useState(null);
  const id = `ai-note-${useId().replace(/:/g, '')}`;
  const open = () => {
    const r = ref.current?.getBoundingClientRect();
    if (!r) return;
    const w = 330;
    const left = Math.max(8, Math.min(r.left, window.innerWidth - w - 8));
    setPos(window.innerHeight - r.bottom > 210 ? { left, top: r.bottom + 8 } : { left, bottom: window.innerHeight - r.top + 8 });
  };
  const close = () => setPos(null);
  useEffect(() => {
    if (!pos) return undefined;
    const onScroll = () => setPos(null);
    const onKey = (e) => { if (e.key === 'Escape') setPos(null); };
    window.addEventListener('scroll', onScroll, true);
    window.addEventListener('keydown', onKey);
    return () => { window.removeEventListener('scroll', onScroll, true); window.removeEventListener('keydown', onKey); };
  }, [pos]);
  return (
    <>
      <span ref={ref} className={`pill pt-state-ai ${className}`.trim()} data-testid={testid} tabIndex={0} style={{ '--ai-delay': delay }}
        aria-describedby={pos ? id : undefined} onMouseEnter={open} onMouseLeave={close} onFocus={open} onBlur={close}>
        <AiTag size={15} testid={tagTestid} /> {text}
      </span>
      {pos && createPortal(
        <div className="ai-note" role="tooltip" id={id} data-testid="ai-note" style={pos}>
          <div className="ai-note-inner">
            <div className="ai-note-head"><AiTag size={14} /><span>{head}</span></div>
            <div className="ai-note-phrase">{text}</div>
            {why && <div className="ai-note-why">{why}</div>}
            {note && <div className="ai-note-foot">{note}</div>}
          </div>
        </div>,
        document.body,
      )}
    </>
  );
}
